// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Shipping40FilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Shipping40Filled: FC<Shipping40FilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="40"
            height="40"
        >
            <path d="m.889 21.93.694-2.777h9.167l-.695 2.777H.89Zm10.5 11.403c-1.39 0-2.542-.495-3.459-1.486-.916-.99-1.328-2.171-1.235-3.542H2.528l.917-3.875h8.569l1.5-6.083h3.5l1.944-7.778H7.388l.445-1.722c.148-.648.47-1.174.966-1.576a2.66 2.66 0 0 1 1.729-.604h19.444l-1.597 6.944h5.097l4.833 6.444-1.638 8.25h-3.334c.093 1.37-.324 2.551-1.25 3.542-.925.99-2.083 1.486-3.472 1.486-1.389 0-2.541-.495-3.458-1.486-.917-.99-1.329-2.171-1.236-3.542H16.11c.093 1.37-.324 2.551-1.25 3.542-.926.99-2.083 1.486-3.472 1.486ZM4.222 15.847l.695-2.778H15.75l-.695 2.778H4.222Zm7.167 14.708c.546 0 1.007-.192 1.382-.576.375-.384.562-.84.562-1.368 0-.546-.187-1.007-.562-1.382a1.879 1.879 0 0 0-1.382-.563c-.528 0-.984.188-1.368.563a1.856 1.856 0 0 0-.576 1.382c0 .528.192.984.576 1.368.384.384.84.576 1.368.576Zm17.222 0c.546 0 1.007-.192 1.382-.576.375-.384.562-.84.562-1.368 0-.546-.187-1.007-.562-1.382a1.878 1.878 0 0 0-1.382-.563c-.527 0-.984.188-1.368.563a1.856 1.856 0 0 0-.576 1.382c0 .528.192.984.576 1.368.384.384.84.576 1.368.576Zm-2.153-8.61h8.653l.222-1.209-3.25-4.347h-4.347l-1.278 5.555Z" />
        </svg>
    );
};

export default Shipping40Filled;
